import React from 'react';
import CardMenuIdeas from "../../../../components/UI/Cards/CardMenuIdeas/CardMenuIdeas";
import {FormattedMessage} from "react-intl";

const RelatedInfo = (props) => {
    let lRelatedInfo;
    lRelatedInfo = props.home_menu_ideas.map(data => {
        return (
            <CardMenuIdeas key={data.menu_idea_cd} data={data} target={"_blank"}/>
        );
    });

    return (
        <>
            {props.home_menu_ideas && props.home_menu_ideas.length < 1 ? <h4>Load data...</h4>
                :
                (
                    props.home_menu_ideas[0].id === null ? <h4>
                            <FormattedMessage id={"proddetail.norelatedmenu"} defaultMessage={"Sorry, no related menu for this product"}/>
                        </h4>
                        : lRelatedInfo
                )
            }
        </>
    )
}

export default RelatedInfo;